import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes, InsightContext } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const RolesContext = React.createContext(null);

const { Provider } = RolesContext;
export const RolesProvider = (props) => {
    
    const { 
        fetchAuthorized 
    } = useContext(FetchContext);
    
    const { 
        trackError 
    } = useContext(InsightContext);
    
    const [state, setState] = useAggregatedState({        
        roles: [],        
        role: null,
        user: null
    });
    
    const [isLoadingRoles, setIsLoadingRoles] = useState(false);
    const getRolesAsync = async () => {  

        try {

            setIsLoadingRoles(true);
            const r = await fetchAuthorized(ApiRoutes.Role.GetRoles(),
                {
                    method: HttpMethods.GET
                });

            const roles = await r.json();
            setState({ roles });
            setIsLoadingRoles(false);

        } catch(e) {
            console.debug(e)
            trackError(e);
            setIsLoadingRoles(false);
        }
    }    

    const [isLoadingRole, setIsLoadingRole] = useState(false);
    const getRoleAsync = async (roleId) => {  

        try {

            setIsLoadingRole(true);
            const r = await fetchAuthorized(ApiRoutes.Role.GetRole({roleId, withUsers: true}),
                {
                    method: HttpMethods.GET
                });

            const role = await r.json();
            setState({ role });
            setIsLoadingRole(false);

        } catch(e) {
            console.debug(e)
            trackError(e);
            setIsLoadingRole(false);
        }
    }   

    const [isLoadingUser, setIsLoadingUser] = useState(false);
    const getUserAsync = async (userKey) => {

        try {

            setIsLoadingUser(true);
            const r = await fetchAuthorized(ApiRoutes.User.GetUser({userKey}),
                {
                    method: HttpMethods.GET
                });

            const user = await r.json();
            setState({ user });
            setIsLoadingUser(false);

        } catch(e) {
            console.debug(e)
            trackError(e);
            setIsLoadingUser(false);
        }        
    }

    const [isAddingInRole, setIsAddingInRole] = useState(false);
    const addUserInRoleAsync = async (data) => {
        try {

            setIsAddingInRole(true);      
            const r = await fetchAuthorized(ApiRoutes.User.AddUserInRole(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify(data)
            });

            const user = await r.json();
            const role = { ...state.role };
            role.members.push(user);
            setState({ role} );
            setIsAddingInRole(false);    
            return true;  
        } catch(e) {
            console.debug(e)
            trackError(e);
            setIsAddingInRole(false);      
            return false;
        }
    }

    const [isUpdatingInRole, setIsUpdatingInRole] = useState(false);
    const updateUserInRoleAsync = async (data) => {
        try {

            setIsUpdatingInRole(true);      
            const r = await fetchAuthorized(ApiRoutes.User.UpdateUserInRole(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify(data)
            });

            const user = await r.json();
            const role = { ...state.role };
            const members = [].concat(role.members);
            members[members.findIndex(x => x.externalKey === user.externalKey)] = user;            
            setState({ role} );
            setIsUpdatingInRole(false);     
            return true; 
        } catch(e) {
            console.debug(e)
            trackError(e);
            setIsUpdatingInRole(false);        
            return false;
        }
    }

    const [isRemovingFromRole, setIsRemovingFromRole] = useState(false);
    const removeUserFromRoleAsync = async (userKey, roleId) => {
        try {

            setIsRemovingFromRole(true);      
            const r = await fetchAuthorized(ApiRoutes.User.RemoveUserFromRole({userKey, roleId}),
            {
                method: HttpMethods.DELETE
            });
            
            const role = { ...state.role };
            role.members = role.members.filter(x => x.externalKey !== userKey);
            setState({ role });
            setIsRemovingFromRole(false);   
            return true;   
        } catch(e) {
            console.debug(e)
            trackError(e);
            setIsRemovingFromRole(false);        
            return false;
        }
    }

    return (
        <Provider value={{

            state,

            isLoadingRoles,
            getRolesAsync,

            isLoadingRole,
            getRoleAsync,

            isLoadingUser,
            getUserAsync,

            isAddingInRole,
            addUserInRoleAsync,

            isUpdatingInRole,
            updateUserInRoleAsync, 

            isRemovingFromRole,           
            removeUserFromRoleAsync            
        }}>
            {props.children}
        </Provider>
    );
}